import React, { useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
// import { RoutePath } from '../../../routes/Routes';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate, useParams } from 'react-router-dom';
import ModalMedia from '../media/modal-media/ModalMedia';
import { linkPreviewImage } from '../../../components/upload-image-preview/UploadImagePreview';
// import { STATUS_ENUM } from '../../manage-articles/enum/article.enum';
import ContainerButton from '../../../components/button/ContainerButton';
import { ManageStateDetail } from './manageStateDetail';
import { IconComponents } from '../../../assets/icons/icons';
import { alertActive, alertError } from '../../../components/alert/swal';
import { Box, Button, IconButton, LinearProgress, LinearProgressProps, Typography, Zoom } from '@mui/material';
import { routeName } from '../../../routes/routeName';
import { useTranslation } from 'react-i18next';
import { debouncedApiCall } from '../../../utils/app.utils';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { STATUS_DATA } from '../../../constants';
import StepperCustom from '../../../components/step/Stepper';
import DescriptionIcon from '@mui/icons-material/Description';
import RecommendIcon from '@mui/icons-material/Recommend';

type Props = {
    view: boolean;
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number, choice_name: string, total_count: number }) {
    const { t } = useTranslation();
    return (
        <Box className="flex justify-start flex-col items-start w-full gap-2">
            <Typography sx={{ color: '#828282' }}>{props.choice_name}</Typography>
            <Box sx={(theme) => ({
                display: 'flex', alignItems: 'center', width: '100%', gap: 4,
                [theme.breakpoints.down('md')]: {
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }
            })}>
                <Box className="flex justify-start items-center gap-6 min-w-[200px]">
                    <Typography fontWeight={700}>
                        {t("{{total}} คน", { total: props.total_count })}
                    </Typography>
                    <Typography
                        fontWeight={700}
                    >
                        {`${Math.round(props.value * 100) / 100}%`}
                    </Typography>
                </Box>
                <Box sx={{ width: '100%', borderRadius: "30px" }}>
                    <LinearProgress sx={{
                        height: ".5rem",
                        borderRadius: "30px",
                        backgroundColor: "#F2F4F7",
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: '#CFA56D',
                            borderRadius: '30px',
                        },
                    }} variant="determinate" {...props} />
                </Box>
            </Box>
        </Box>
    );
}

const PollVoteDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    // const [is_copy, set_is_copy] = useState<boolean>(false);

    const {
        formState,
        handleChangeFormState,
        handleSubmit,
        errorMessage,
        id_media_file,
        set_file_api_url,
        set_id_media_file,
        showModal,
        setFormState,
        handleCloseModal,
        image_api,
        handleChangeImageApi,
        setShowModal,
        handleDeleteImageApi,
        poll_type_data,
        set_search_poll_type,
        id_poll_type,
        set_id_poll_type,
        form_poll_choice,
        handleAddPollVote,
        handleRemovePollVote,
        handleChangeFormPoll,
        form_poll_choice_vote,
        status
    } = ManageStateDetail();

    const [step, setStep] = useState<number>(0);

    const total_chart_count = form_poll_choice_vote?.reduce((x, y) => x + Number(y.count || 0), 0) || 0
    return (
        <ContainerLayout
            title=''
            titleName={id ? t('รายละเอียดโพลโหวต') : t('เพิ่มโพลโหวต')}
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โพลโหวต", // i18n-ignore
                                name: t("โพลโหวต"),
                                pathName: routeName.cms_website.poll_vote
                            },
                            ...((id && view) ? [
                                {
                                    key: "calendar_activity-view",
                                    name: t("รายละเอียดโพลโหวต"),
                                    pathName: routeName.cms_website.poll_vote_view.replace(":id", id),
                                },
                            ] : (id && !view) ? [
                                {
                                    key: "calendar_activity_detail",
                                    name: t("รายละเอียดโพลโหวต"),
                                    pathName: routeName.cms_website.poll_vote_detail.replace(":id", id),
                                },
                            ] : [
                                {
                                    key: "website_structure_content_create",
                                    name: t("เพิ่มโพลโหวต"),
                                    pathName: routeName.cms_website.poll_vote_create,
                                },
                            ])
                        ]}
                />
            }

            buttonContent={
                <div className='w-full flex justify-end items-center gap-2'>
                    <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{ maxWidth: "fit-content" }}
                        buttonData={[
                            {
                                key: "BACK",
                                buttonProps: {
                                    onClick: () => navigate(-1)
                                },
                                label: t("ย้อนกลับ"),
                                seq: 1,
                                type: "BACK"
                            },
                            {
                                key: "SAVE_DRAFT",
                                hidden: view || status === STATUS_DATA.ACTIVE,
                                buttonProps: {
                                    onClick: () => handleSubmit("DRAFT")
                                },
                                label: t("บันทึกร่าง", { context: "action" }),
                                seq: 2,
                                type: "SAVE_DRAFT"
                            },
                            {
                                key: "SAVE",
                                hidden: view,
                                buttonProps: {
                                    onClick: () => {
                                        alertActive(t("บันทึกข้อมูล"), t("ท่านต้องการบันทึกข้อมูลพร้อมเผยแพร่โพลโหวต?"), t("บันทึกพร้อมเผยแพร่"), t("ยกเลิก"), () => {
                                            handleSubmit("SUBMIT")
                                        })
                                    }
                                },
                                label: t("บันทึก"),
                                seq: 3,
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }
            content={
                <>
                    {status === STATUS_DATA.ACTIVE && (
                        <div className='flex justify-center items-center'>
                            <StepperCustom
                                sx={{ maxWidth: 'fit-content' }}
                                setStep={(s) => setStep(s)}
                                step={step}
                                view
                                stepLabel={[
                                    {
                                        icon: <DescriptionIcon />,
                                        isAccept: false,
                                        name: t("รายละเอียด"),
                                    },
                                    {
                                        icon: <RecommendIcon />,
                                        isAccept: false,
                                        name: t("ผลโหวต"),
                                    },
                                ]}
                            />
                        </div>
                    )}
                    {step === 0 && (
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "SWITCH",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            disabled: view,
                                            checked: formState.is_public ? true : false,
                                            onChange: (val) => handleChangeFormState('is_public', val ? 1 : 0),
                                            label: t("สถานะการเผยแพร่")
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_date,
                                            required: true,
                                            onChange: (date) => handleChangeFormState('form_poll_public_start', date),
                                            value: formState.form_poll_public_start,
                                            heading: t("วันที่เริ่มต้นเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_date,
                                            required: true,
                                            disabled: view || !formState.form_poll_public_start,
                                            disableStartDate: formState.form_poll_public_start,
                                            onChange: (date) => handleChangeFormState('form_poll_public_end', date),
                                            value: formState.form_poll_public_end,
                                            heading: t("วันที่สิ้นสุดเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_start_time,
                                            required: true,
                                            value: formState.form_poll_public_start_time,
                                            onChange: (e) => handleChangeFormState('form_poll_public_start_time', e),
                                            heading: t("เวลาที่เริ่มต้นเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            helperText: errorMessage.content_end_time,
                                            required: true,
                                            value: formState.form_poll_public_end_time,
                                            onChange: (e) => {
                                                handleChangeFormState('form_poll_public_end_time', e)
                                            },
                                            heading: t("เวลาที่สิ้นสุดเผยแพร่"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                ]}
                            />
                            <StateComponents
                                heading={t('รายละเอียดโพลโหวต')}
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                heading_props={{
                                    fontSize: 16,
                                    variantHeading: 'h6'
                                }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            placeholder: t("ระบุชื่อ"),
                                            onChange: (e) => handleChangeFormState('form_poll_name', e.target.value),
                                            heading: t("ชื่อ"),
                                            value: formState.form_poll_name
                                        },
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (date) => handleChangeFormState('form_poll_start', date),
                                            value: formState.form_poll_start,
                                            heading: t("วันที่เริ่มเปิดโหวต"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            disabled: view || !formState.form_poll_start,
                                            disableStartDate: formState.form_poll_start,
                                            onChange: (date) => handleChangeFormState('form_poll_end', date),
                                            value: formState.form_poll_end,
                                            heading: t("วันที่ปิดโหวต"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            value: formState.form_poll_start_time,
                                            onChange: (e) => handleChangeFormState('form_poll_start_time', e),
                                            heading: t("เวลาที่เปิดโหวต"),
                                            placeholder: t("ระบุ")
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            value: formState.form_poll_end_time,
                                            onChange: (e) => {
                                                handleChangeFormState('form_poll_end_time', e)
                                            },
                                            heading: t("เวลาที่ปิดโหวต"),
                                            placeholder: t("ระบุ")
                                        }
                                    },

                                    {
                                        seq: 6,
                                        type: 'AUTO-COMPLETE',
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.poll_type || "",
                                            labelId: "country",
                                            heading: t('หมวดหมู่'),
                                            placeholder: t('ระบุหมวดหมู่'),
                                            onChange: (_, val) => {
                                                set_id_poll_type(val?.id_poll_type ?? null);
                                            },
                                            onInputChange: (_: any, val: any) => {
                                                debouncedApiCall({ searchItem: val, setItem: set_search_poll_type });
                                            },
                                            options: poll_type_data || [],
                                            value: poll_type_data?.find((x) => x?.id_poll_type === id_poll_type) || null
                                        }
                                    },
                                ]}
                            />
                            <div className='w-full shadow-md py-4 my-10 rounded-xl px-4'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "MULTI_UPLOAD_IMAGE",
                                            gridProps: {
                                                xs: 12
                                            },
                                            fieldProps: {
                                                handleDeleteImageApi: (_, i) => handleDeleteImageApi(i),
                                                handleDeleteImageSelect: (_, i) => { },
                                                onChange: () => { },
                                                tabIndex: 2,
                                                valueAddFile: [],
                                                heading: t('ไฟล์ภาพหน้าปก'),
                                                onUploadMedia: () => {
                                                    if (image_api?.length > 0) {
                                                        return alertError(t("เลือก ไฟล์ภาพหน้าปก ได้แค่ 1 รูปเท่านั้น"))
                                                    }
                                                    setShowModal("ADD")
                                                },
                                                is_using_modal_media: true,
                                                disabled: view,
                                                addImageIcon: <IconComponents.UploadImageFileIcon />,
                                                valueImage: image_api || []
                                            }
                                        },
                                    ]}
                                />
                            </div>
                            <div className='w-full shadow-md py-4 my-10 rounded-xl px-4'>
                                <Typography variant='h6'>
                                    {t("ตัวเลือกในการโหวต")}
                                </Typography>
                                <Box my={2} className="flex flex-col gap-4 justify-start items-center">
                                    {form_poll_choice?.map((list, index) => {
                                        return (
                                            <Zoom key={index} in>
                                                <Box className="w-full flex justify-start items-center">
                                                    <IconButton onClick={() => handleRemovePollVote(index)}>
                                                        <RemoveCircleOutlineIcon color="error" />
                                                    </IconButton>
                                                    <Box className="flex-1">
                                                        <StateComponents
                                                            typeProps={[
                                                                {
                                                                    seq: 1,
                                                                    type: "TEXT_FIELD",
                                                                    gridProps: {
                                                                        xs: 12,
                                                                        md: 4
                                                                    },
                                                                    fieldProps: {
                                                                        noBorder: true,
                                                                        placeholder: t("ระบุตัวเลือก"),
                                                                        onChange: (e) => handleChangeFormPoll('form_poll_choice', e.target.value, index),
                                                                        value: list.form_poll_choice
                                                                    }
                                                                }
                                                            ]}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Zoom>
                                        )
                                    })}
                                </Box>
                                <Box className="flex justify-start items-center">
                                    <IconButton onClick={handleAddPollVote}>
                                        <Box sx={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: "#FFF2DA" }}></Box>
                                    </IconButton>
                                    <Button onClick={handleAddPollVote}>
                                        <Typography sx={{ color: "#828282" }}>
                                            {t("เพิ่มหัวข้อย่อย...")}
                                        </Typography>
                                    </Button>
                                </Box>
                            </div>

                            {showModal !== "" && (
                                <ModalMedia
                                    open
                                    handleClose={handleCloseModal}
                                    title={t('เพิ่มไฟล์')}
                                    id_media_file={id_media_file}
                                    // select_one
                                    multiple
                                    onSelectMediaFile={(_, id) => set_id_media_file(id)}
                                    onSubmitMediaFile={async (_, id_media_file) => {
                                        handleCloseModal();
                                        const path = await linkPreviewImage(id_media_file);
                                        set_file_api_url(path);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        // handleSubmit(id_media_file);
                                    }}
                                    onSubmitMediaFileMultiple={(media_file) => {
                                        if (media_file?.length > 1) {
                                            return alertError(t("เลือก ไฟล์ภาพหน้าปก ได้แค่ 1 รูปเท่านั้น"))
                                        }
                                        handleChangeImageApi(media_file);
                                    }}
                                    onSubmitLocalFile={async (id_media_file) => {
                                        const path = await linkPreviewImage(id_media_file);
                                        setFormState((prev) => ({ ...prev, id_media_file }))
                                        set_file_api_url(path);
                                        handleCloseModal();
                                        // handleSubmit(id_media_file);
                                    }}
                                />
                            )}
                        </div>

                    )}
                    {step === 1 && (
                        <Box className="w-full flex flex-col gap-4 items-start justify-start py-5">
                            <Box className="flex justify-start items-center gap-2">
                                <Typography variant='h5' textAlign={"left"}>
                                    {t("จำนวนผู้โหวต :")}
                                </Typography>
                                <Typography fontWeight={600} sx={{ color: "#FCAF17" }} variant='h5'>
                                    {total_chart_count}
                                </Typography>
                            </Box>
                            <Box display={"flex"} gap={2} flexDirection={"column"} sx={{ width: '100%' }}>
                                {form_poll_choice_vote?.map((list, i) => {
                                    const percentage: number = (Number(list?.count || 0) / Number(total_chart_count || 1)) * 100;
                                    return <LinearProgressWithLabel
                                        key={`${list?.id_form_poll_choice}_${i}`}
                                        choice_name={list?.form_poll_choice || "-"}
                                        total_count={list?.count || 0}
                                        value={percentage}
                                    />
                                })}
                            </Box>
                        </Box>
                    )}
                </>
            }
        />
    )
}

export default PollVoteDetail